import { Reveal } from "./Reveal";

const PARAGRAPHS = [
  "Framgångsrik identitetshantering handlar om betydligt mer än att välja rätt produkt eller teknik.",
  "Därför börjar IC Identity med att förstå verksamheten, nuläget och målen. Först därefter formas rätt väg framåt.",
  "Resultatet ska vara identitetshantering som inte bara är säker, utan också begriplig, hanterbar och hållbar över tid.",
];

export const Manifesto = () => (
  <section className="bg-brand-ink text-white">
    <div className="mx-auto max-w-6xl px-6 py-24 md:py-36 lg:px-8">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10">
        <div className="md:col-span-7">
          <Reveal>
            <p className="eyebrow text-brand-blue-soft">
              <span className="ic-triangle" style={{ borderBottomColor: "#7CA6D6" }} aria-hidden="true" />
              Vårt arbetssätt
            </p>
            <h2 className="mt-7 font-display text-3xl font-normal leading-[1.08] tracking-[-0.01em] text-white md:text-6xl">
              Tekniken är inte utgångspunkten. Verksamheten är.
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-5 md:pt-2">
          <div className="space-y-6">
            {PARAGRAPHS.map((para, i) => (
              <Reveal key={i} delay={0.08 + i * 0.06}>
                <p className="text-lg leading-relaxed text-white/70">{para}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
